import { Email, Phone } from '@mui/icons-material'
import { Card, Chip, Grid, Typography } from '@mui/material'
import ArgonBox from 'components/ArgonBox'
import ArgonTypography from 'components/ArgonTypography'
import { useArgonController } from 'context'

const OpdCard = ({ namaOpd, kepalaOpd, alamat, email, telp }) => {
    const [controller] = useArgonController();
    const { darkMode } = controller;
    return (
        <Card>
            <ArgonBox>
                <ArgonBox p={2}>
                    <Grid container alignItems="center">
                        <Grid item xs={12}>
                            <ArgonBox lineHeight={1}>
                                <ArgonTypography
                                    variant="h6"
                                    textTransform="uppercase"
                                    color={darkMode ? 'white' : 'dark'}
                                    fontWeight='bold'
                                >
                                    {namaOpd}
                                </ArgonTypography>
                            </ArgonBox>
                        </Grid>
                        <Grid item xs={12}>
                            <ArgonBox lineHeight={2}>
                                <Typography
                                    variant="subtitle2"
                                    color='text'
                                    fontWeight='bold'
                                    sx={{
                                        opacity: 0.7
                                    }}
                                >
                                    {kepalaOpd}
                                </Typography>
                            </ArgonBox>
                        </Grid>
                        <Grid item xs={12}>
                            <ArgonBox lineHeight={2}>
                                <Typography
                                    variant="button"
                                    color='text'
                                >
                                    {alamat || "-"}
                                </Typography>
                            </ArgonBox>
                        </Grid>
                        <Grid item xs={12}>
                            <Chip icon={<Email />} label={email || 'Tidak ada Data Email'} color='primary' variant="outlined" /> <Chip icon={<Phone />} label={telp || 'Tidak ada Data Telp'} color='primary' />
                        </Grid>
                    </Grid>
                </ArgonBox>
            </ArgonBox>
        </Card>
    )
}

export default OpdCard